// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueTouch from 'vue-touch';
import App from './App';

// es6 polyfill
import 'babel-polyfill';

// Workaround for dealing with webpack + leaflet issues
// See comment: https://github.com/KoRiGaN/Vue2Leaflet/issues/96#issuecomment-341453050
import L from 'leaflet';
delete L.Icon.Default.prototype._getIconUrl;

// Set up mobile touch events
VueTouch.registerCustomEvent('vertical-swipe', {
  type: 'swipe',
  direction: 'vertical'
});
Vue.use(VueTouch);

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: {App},
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js